export const PaymentEntered = 'PaymentEntered';
export const ScheduleFiltersUpdated = 'ScheduleFiltersUpdated';